<template>
  <resource-container></resource-container>
</template>
<script>
import ResourceContainer from '@/components/resource/Container.vue'
export default {
  name: 'resource',
  components: {
    ResourceContainer
  }
}
</script>
